import React from 'react';
import { NoteIcon, Pencil } from 'assets/icons';
import Button from 'components/button';

// The three colours come from the design and are used nowhere else, so they
// stay arbitrary values rather than entering the Tailwind palette; promote
// them if a second component ever needs the same set.
//
// Only the icon reads this constant — a colour prop, not a class. The title's
// class spells the same value out literally, because Tailwind scans source
// files for complete class strings and would never generate `text-[${...}]`.
export const POST_IT_TITLE_COLOR = '#8D7F3C';

/**
 * The company note, rendered identically wherever it appears: the company
 * sheet, the timesheet detail and the mission contract view.
 *
 * Renders nothing when the note is empty — the card is never an empty shell.
 * `onEdit` is what separates the writable copy in the company sheet from the
 * read-only ones: omit it and no pencil is shown.
 */
const PostIt = ({ content, companyName, onEdit, className = '' }) => {
  const text = (content ?? '').trim();
  if (!text) return null;

  return (
    <div className={`bg-[#F0E18C] rounded p-3 flex gap-2 ${className}`}>
      <div className={'flex flex-col gap-1 min-w-0 flex-1'}>
        <div className={'flex gap-1.5 items-center text-[#8D7F3C] ft-sm'}>
          <NoteIcon wh={16} color={POST_IT_TITLE_COLOR} />
          <span className={'uppercase'}>
            Post-it{companyName ? ` · ${companyName}` : ''}
          </span>
        </div>
        {/* whitespace-pre-line, not a rich text renderer: the note is stored as
            plain text and its line breaks are the only formatting it carries. */}
        <div className={'text-[#5C4D0A] whitespace-pre-line break-words'}>
          {text}
        </div>
      </div>
      {onEdit && (
        <div className={'shrink-0'}>
          <Button size={'SMI'} color={'DEFAULT'} onClick={onEdit}>
            <Pencil wh={20} color={'#111827'} />
          </Button>
        </div>
      )}
    </div>
  );
};

export default PostIt;
